import { render, staticRenderFns } from "./manager-header.vue?vue&type=template&id=60e0eef0&scoped=true&lang=pug&"
import script from "./manager-header.vue?vue&type=script&lang=js&"
export * from "./manager-header.vue?vue&type=script&lang=js&"
import style0 from "./manager-header.vue?vue&type=style&index=0&id=60e0eef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e0eef0",
  null
  
)

export default component.exports